// extracted by mini-css-extract-plugin
module.exports = {"container":"numberBreakdownSection-module--container--GpG9P","numberContainer":"numberBreakdownSection-module--number-container--EgBos"};